module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUBAMAAABohZD3AAAAIVBMVEUANa0OQLISQ7NNcsZti9CwwObULhL6+/37/P78/f7///94pXrhAAAALUlEQVQY02NgAIFVcMCAyRdE47ug8lUrglD4jDMFUPjMLgb4zcfPT0MFg40PAJkSgJL66kKrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/cl.png
// module id = 796
// module chunks = 0